import { message } from "antd";
import axios from "axios";
import { useContext, useEffect, useState } from "react";

import ModalSelectProductView from "../../../components/modalSelectProduct";
import { convertVVolumeToVolume } from "../../../utils/format";
import { AddOrderDeliveryContext } from "./AddOrderDeliveryContext";

const ModalSelectProduct = ({
  visible = false,
  selectedProducts = [],
  wareHouseCode = "",
  branchCode = "",
  onCancel = () => undefined,
  id = "",
  selectedCustomer = "",
}) => {
  const [products, setProducts] = useState([]);
  const [searchResult, setSearchResult] = useState();
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState({ brand: "", category: "" });
  const [loading, setLoading] = useState(false);

  const addContext = useContext(AddOrderDeliveryContext);

  const getProductLocationDetail = (item) => {
    let location = {
      productLocation: "",
      productLocationCode: "",
    };
    if (wareHouseCode) {
      location.productLocation = "W";
      location.productLocationCode = wareHouseCode;
      location.productPositionCode = item?.positionCode;
    }
    if (branchCode) {
      location.productLocation = "M";
      location.productLocationCode = branchCode;
    }
    return location;
  };

  const checkMinStock = (item) => {
    if (item.minStock == null || item.availableStock == null) return;
    const notified = addContext.minStockNotifiedProducts.find(
      (el) => el._id === item._id
    );

    if (notified) return;

    if (!notified && item.availableStock <= item.minStock) {
      addContext.setMinStockNotifiedProducts((prev) => [...prev, item]);

      // Үлдэгдэл цэнэглэх сануулга тул анзаарагдахаар удаан харуулна
      message.error(
        `${item.productSku} кодтой "${item.title}" барааны үлдэгдэл таны тохируулсан хэмжээнд хүрлээ. Та үлдэгдлээ цэнэглэнэ үү !!!`,
        40
      );
    }
  };

  const addProducts = (params = []) => {
    let products = params.map((item) => {
      checkMinStock(item);

      return {
        ...item,
        ...getProductLocationDetail(item),
      };
    });

    if (wareHouseCode) {
      addContext.addProductWarehouse(id, products);
    } else {
      addContext.addProductBranch(id, products);
    }
  };

  const handleCheckProduct = (i, checked) => {
    products[i].checked = checked;
    setProducts([...products]);
  };

  const onSearchProduct = (val, event, page = 1, options = {}) => {
    const searchValue = val || "";
    const {
      brand = filter.brand,
      category = filter.category,
      reset = false,
    } = options;
    setSearchText(searchValue);

    //Брэнд болон Категори filter
    const filterQuery = `${brand ? `&brand=${encodeURIComponent(brand)}` : ""}${
      category ? `&category=${encodeURIComponent(category)}` : ""
    }`;

    //Агуулахаас эсвэл салбараас бараа хайх
    const url = wareHouseCode
      ? `/api/v1/request/productSearch?query=${searchValue}&selectedCustomer=${selectedCustomer}&wareHouseCode=${wareHouseCode}${
          page ? `&page=${page}` : ""
        }${filterQuery}`
      : `/api/v1.0/product/search?query=${searchValue}${
          page ? `&page=${page}` : ""
        }&selectedCustomer=${selectedCustomer}${filterQuery}`;

    setLoading(true);
    axios
      .get(url)
      .then(({ data }) => {
        if (data.statusCode === 200) {
          setSearchResult(data.result);
          if (page === 1 && data?.result?.docs?.length === 0) {
            if (reset) setProducts([]);

            message.error("Таны хайсан бараа олдсонгүй!");
          }

          if (data?.result?.docs?.length > 0) {
            const resProducts = data.result.docs.map((item) => {
              let obj = {
                ...item,
                totalUnit: 0,
              };
              if (wareHouseCode) {
                obj.volume = convertVVolumeToVolume(item.vVolume);
              }
              return obj;
            });

            selectedProducts?.forEach((item) => {
              for (const product of resProducts) {
                if (
                  item._id === product?._id &&
                  item.expiryDate === product?.expiryDate
                ) {
                  product.checked = true;
                  break;
                }
              }
            });

            setProducts((prev) => [
              ...(!reset &&
              searchText === searchValue &&
              searchResult?.page !== page
                ? prev
                : []),
              ...resProducts,
            ]);
          }
        }
      })
      .catch((e) => {
        console.error("Бараа хайх: ", e);
      })
      // Амжилттай эсэхээс үл хамааран loading заавал унтарна
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    onSearchProduct();
    // Модал нээгдэхэд эхний жагсаалтыг нэг удаа татна.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFilterChange = (key, value) => {
    const nextFilter = { ...filter, [key]: value || "" };
    setFilter(nextFilter);
    onSearchProduct(searchText, null, 1, { ...nextFilter, reset: true });
  };

  const onOk = () => {
    let selProdClone = [...selectedProducts];

    const listAdd = [];

    products.forEach((item) => {
      const isItemSelected = selectedProducts.find(
        (el) => el?._id === item?._id && el?.expiryDate === item?.expiryDate
      );

      if (item.checked && !isItemSelected) {
        // item.totalUnit = 0;
        listAdd.push(item);
      }
      // id adilhan bolovch expiryDate n uur baraag uncheck hiine
      if (!item.checked && isItemSelected) {
        selProdClone = selProdClone.filter(
          (el) =>
            el._id !== item._id ||
            (el._id === item._id && el?.expiryDate !== item?.expiryDate)
        );
      }
    });

    const outOfStockProduct = listAdd.find((p) => p.availableStock === 0);

    if (outOfStockProduct) {
      message.error(`${outOfStockProduct.title} бараа агуулахаас дууссан байна!`);
      return;
    }

    addProducts([...selProdClone, ...listAdd]);
    onCancel();
  };
  return (
    <ModalSelectProductView
      isModalVisible={visible}
      handleOk={onOk}
      handleCancel={onCancel}
      onSearchProduct={onSearchProduct}
      productList={products}
      searchText={searchText}
      searchResult={searchResult}
      handleCheckProduct={handleCheckProduct}
      showFilter
      filterValues={filter}
      onFilterChange={onFilterChange}
      loading={loading}
      centered
    />
  );
};

export default ModalSelectProduct;
